import { Button, Tooltip } from '@harvesthq/porchlight'
import { useState } from 'preact/compat'

import { signOut } from '../lib/authentication'

import { formattedTime } from '../lib/helpers/time'
import { buildTimesheetUrl, accountsUrl } from '../lib/urls'
import { switchOrSelectAccount } from '../lib/util'

const serviceIconImage = (iconUrl) =>
  iconUrl && (
    <img
      className="pds-mb-xs"
      width="16"
      height="16"
      src={iconUrl}
      alt="Service icon"
    />
  )

const timesheetLink = (chromeless, timesheetUrl) => {
  if (!chromeless || !timesheetUrl) return null

  return (
    <>
      {' '}
      in{' '}
      <a
        key="link-to-timesheet"
        href={timesheetUrl.href}
        target="_blank"
        rel="noopener"
      >
        Harvest
      </a>
    </>
  )
}

const switchAccountOrSignOutLink = (chromeless, userCanSwitchAccounts) => {
  if (!chromeless) return null

  return userCanSwitchAccounts ? (
    <Button
      aria-label="Switch account."
      label="Switch account"
      variant="link"
      onClick={() => switchOrSelectAccount(accountsUrl)}
    />
  ) : (
    <Button
      aria-label="Sign out."
      label="Sign out"
      variant="link"
      onClick={signOut}
    />
  )
}

export function TimerSummary({
  baseUri,
  userCanSwitchAccounts,
  totalHours,
  iconUrl,
  serviceName,
  chromeless,
  externalItemName,
}) {
  const [showTooltip, setShowTooltip] = useState(
    !localStorage.getItem('dismissed_asana_tooltip') &&
      serviceName === 'app.asana.com'
  )

  if (totalHours === null) return null
  let timesheetUrl = null

  if (baseUri) {
    timesheetUrl = buildTimesheetUrl(baseUri)
  }

  const itemName = externalItemName ? (
    <strong>{externalItemName}</strong>
  ) : (
    'This item'
  )

  const formattedHours = formattedTime(totalHours)

  const closeTooltip = (e) => {
    e.preventDefault()
    setShowTooltip(false)
    localStorage.setItem('dismissed_asana_tooltip', true)
  }

  const TooltipContent = () => (
    <div className="pds-position-relative">
      <button
        className="close-button"
        aria-label="Close tooltip"
        onClick={closeTooltip}
      >
        &times;
      </button>
      <h5 className="pds-mb-sm">Asana task links in Harvest</h5>
      <p className="pds-m-0">
        When you track time to a task in Asana we’ll include a link to that task
        in the Harvest time entry.
      </p>
    </div>
  )

  return (
    <div className="pds-position-relative">
      {showTooltip && (
        <Tooltip
          id="asana-tooltip"
          className="pds-tooltip pds-tooltip-top"
          visible={showTooltip}
          content={TooltipContent}
        />
      )}
      <div className="pds-mt-md pds-valign-middle pds-text-middle pds-color-gray">
        {serviceIconImage(iconUrl)} {itemName} has{' '}
        <strong>{formattedHours}</strong> tracked to it
        {timesheetLink(chromeless, timesheetUrl)}.{' '}
        {switchAccountOrSignOutLink(chromeless, userCanSwitchAccounts)}
      </div>
    </div>
  )
}
